import { IconButton, Tooltip, Typography } from '@material-ui/core';

import moment from 'moment';
import RemoveIcon from '@material-ui/icons/Remove';
import LockIcon from '@material-ui/icons/Lock';
import CachedIcon from '@material-ui/icons/Cached';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import { HeadingTableCell } from './tableStyle';

export default function WeekDaysHeader(props) {
    const {
        index,
        tCardList,
        isToday,
        dt,
        curretDate,
        iscloseDay,
        handlePlusButtonClick,
        tCardCalendarID,
        dayfull,
        hours,
        handletSetDayFull,
        changeWeek,
        count
    } = props;

    return (
        <HeadingTableCell
            key={index} // Added key prop for React optimization
            align="center"
            style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}
        >
            <div
                style={{
                    backgroundColor: isToday ? '#49B265' : '',
                    color: isToday ? 'white' : 'black',
                    position: 'relative',
                    border: '1px solid rgba(0,0,0,0.04)'
                }}
            >
                <Typography
                    style={{
                        textAlign: 'center',
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 17
                    }}
                >
                    WEEK- {moment(dt).isoWeek()}
                    {moment(dt).format('YYYY-MM-DD') < moment(curretDate).format('YYYY-MM-DD') && iscloseDay && (
                        <div style={{ position: 'absolute', right: 10 }}>
                            &nbsp;{' '}
                            <Tooltip title="Close Day" aria-label="remove">
                                <IconButton
                                    size="small"
                                    style={{
                                        backgroundColor: '#808080',
                                        color: 'white',
                                        padding: '4px',
                                        borderRadius: '4px',
                                        width: '15px',
                                        height: '15px'
                                    }}
                                    onClick={() => handlePlusButtonClick(tCardCalendarID)}
                                >
                                    <RemoveIcon fontSize="small" style={{ fontSize: '12px', margin: '2px' }} />
                                </IconButton>
                            </Tooltip>
                        </div>
                    )}
                    {/* {!dayfull && ( */}
                    <div style={{ position: 'absolute', right: 30 }}>
                        &nbsp;{' '}
                        <Tooltip title={dayfull ? 'Reset Full Day' : 'Set Full Day'} aria-label="remove">
                            <IconButton
                                size="small"
                                style={{
                                    backgroundColor: '#808080',
                                    color: 'white',
                                    padding: '4px',
                                    borderRadius: '4px',
                                    width: '15px',
                                    height: '15px'
                                }}
                                onClick={() => handletSetDayFull(dt, dayfull ? 'open' : 'set')}
                            >
                                {dayfull ? (
                                    <CachedIcon fontSize="small" style={{ fontSize: '12px', margin: '2px' }} />
                                ) : (
                                    <LockIcon fontSize="small" style={{ fontSize: '12px', margin: '2px' }} />
                                )}
                            </IconButton>
                        </Tooltip>
                    </div>
                    {/* )} */}
                </Typography>
                <Typography
                    style={{
                        textAlign: 'center',
                        fontWeight: 800,
                        textTransform: 'uppercase',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: 12,
                        color: dayfull ? 'red' : ''
                    }}
                >
                    {tCardList.closeDays.length > 6 ? moment(dt).format('ddd') : moment(dt).format('dddd')}
                    &nbsp; {moment(dt).format('DD-MMM-YY')}
                </Typography>

                <div>
                    <span
                        style={{
                            // backgroundColor: '#808080',
                            // color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderRadius: '4px',
                            width: 'auto',
                            padding: '0px 3px'
                        }}
                    >
                        <span style={{ fontSize: 11, marginLeft: 3, fontWeight: 600 }}>
                            Loan - <span>{hours?.loanVehiclesBooked || '0'}</span>
                        </span>
                        <span style={{ fontSize: 11, marginLeft: 3, fontWeight: 600 }}>
                            Booked - {hours?.allocatedHours || 0} {`(${hours?.dayAllocatedHours || 0} / ${hours?.nightAllocatedHours || 0})`}
                            &nbsp;
                        </span>
                    </span>
                </div>
                {/* Right arrow navigation on the last item */}
                {index === tCardList.closeDays.length - 1 && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 10,
                            right: -6
                        }}
                    >
                        <NavigateNext
                            style={{
                                fontSize: 30,
                                color: 'black',
                                cursor: 'pointer'
                            }}
                            onClick={() => changeWeek('next')}
                        />
                    </div>
                )}
                {index === 0 && count > 0 && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: 10,
                            left: -6
                        }}
                    >
                        <NavigateBefore
                            style={{
                                fontSize: 30,
                                color: 'black',
                                cursor: 'pointer'
                            }}
                            onClick={() => changeWeek('prew')}
                        />
                    </div>
                )}
            </div>
        </HeadingTableCell>
    );
}
